import { refreshAuthToken } from "../auth/cognito";
import { API_ORIGIN } from "../config/api";

class ApiClient {
  constructor() {
    this.baseURL = API_ORIGIN;
    this.isRefreshing = false;
    this.failedQueue = [];
  }

  processQueue(error, token = null) {
    this.failedQueue.forEach((promise) => {
      if (error) {
        promise.reject(error);
      } else {
        promise.resolve(token);
      }
    });
    this.failedQueue = [];
  }

  async request(url, options = {}) {
    const token = localStorage.getItem("mg_token");

    const config = {
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
        ...(token && { Authorization: `Bearer ${token}` }),
      },
    };

    try {
      const response = await fetch(`${this.baseURL}${url}`, config);

      if (response.status === 401) {
        if (!this.isRefreshing) {
          this.isRefreshing = true;

          try {
            const newToken = await refreshAuthToken();
            this.isRefreshing = false;

            config.headers.Authorization = `Bearer ${newToken}`;
            const retryResponse = await fetch(`${this.baseURL}${url}`, config);

            if (retryResponse.ok) {
              this.processQueue(null, newToken);
              return retryResponse;
            }
          } catch (refreshError) {
            this.isRefreshing = false;
            this.processQueue(refreshError, null);

            localStorage.removeItem("mg_token");
            localStorage.removeItem("mg_session_hint");
            window.location.href = "/login";
            throw refreshError;
          }
        } else {
          return new Promise((resolve, reject) => {
            this.failedQueue.push({ resolve, reject });
          }).then(() => {
            const newToken = localStorage.getItem("mg_token");
            config.headers.Authorization = `Bearer ${newToken}`;
            return fetch(`${this.baseURL}${url}`, config);
          });
        }
      }

      return response;
    } catch (error) {
      console.error("API request failed:", error);
      throw error;
    }
  }

  async get(url, options = {}) {
    return this.request(url, { ...options, method: "GET" });
  }

  async post(url, data, options = {}) {
    return this.request(url, {
      ...options,
      method: "POST",
      body: JSON.stringify(data),
    });
  }

  async put(url, data, options = {}) {
    return this.request(url, {
      ...options,
      method: "PUT",
      body: JSON.stringify(data),
    });
  }

  async delete(url, options = {}) {
    return this.request(url, { ...options, method: "DELETE" });
  }
}

export const apiClient = new ApiClient();
